import fetchClient from './fetchClient';
import { errorHandler } from './utils';


const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export const getIngredient = async (id: string) => {
    const res = await fetchClient.get(`/ingredients/${id}`, config()).catch((err: any) => {
        return null;
    });
    if (!res) return null;
    return res.data;
};

export const deleteIngredient = async (id: string) => {
    const res: any = await fetchClient
        .delete(`/ingredients/${id}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const updateIngredient = async (ingredient: any) => {
    const id = ingredient._id;
    delete ingredient._id;
    const rest = await fetchClient
        .put(`/ingredients/${id}`, ingredient, config())
        .catch(errorHandler);
    return rest.data;
};
